// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardView-module_card__aeIbV {
    width: 327px;
    height: 218px;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid var(--grey_16_lc);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.cardView-module_disabled__Eyg23 {
    border-color: var(--grey_8_lc);
}

.cardView-module_container__J4U89 {
    display: flex;
    justify-content: space-between;
}
.cardView-module_accountContainer__GZCkG {
    display: flex;
    gap: 10px;
}

.cardView-module_header__WA7Rx {
    display: flex;
    align-items: center;
}

.cardView-module_footer__Z7DZL {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.cardView-module_panView__EaJ6_ {
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.cardView-module_accountView__GmumY {
    display: flex;
    flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Card/cardView.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mCAAmC;IACnC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".card {\n    width: 327px;\n    height: 218px;\n    padding: 24px;\n    border-radius: 16px;\n    border: 1px solid var(--grey_16_lc);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.disabled {\n    border-color: var(--grey_8_lc);\n}\n\n.container {\n    display: flex;\n    justify-content: space-between;\n}\n.accountContainer {\n    display: flex;\n    gap: 10px;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n}\n\n.footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.panView {\n    height: 80px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.accountView {\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `cardView-module_card__aeIbV`,
	"disabled": `cardView-module_disabled__Eyg23`,
	"container": `cardView-module_container__J4U89`,
	"accountContainer": `cardView-module_accountContainer__GZCkG`,
	"header": `cardView-module_header__WA7Rx`,
	"footer": `cardView-module_footer__Z7DZL`,
	"panView": `cardView-module_panView__EaJ6_`,
	"accountView": `cardView-module_accountView__GmumY`
};
export default ___CSS_LOADER_EXPORT___;
